// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2lNcW","footer":"ModalFilter_footer__360tF"};